import {ACTION_CODE} from './_actionCode';
import {InvoiceService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
import { GetAllInvoicesSchemaType } from '../../services/invoiceService/_schema/getAllInvoices.schema';
import { UserState } from '../../reducers/UserReducer';

const FUNCTION_CODE = 'GET_ALL_INVOICES';

export async function getAllInvoices(
    userData: UserState['userProfileData'],
    optionalProps: string,
    page = 1,
) {
    try {
        LoggerService.logInfo('Action - getAllInvoices - Start');

        const getAllinvoicesResult = await InvoiceService.getAllInvoices(userData, optionalProps, page);

        const {data, metadata} = getAllinvoicesResult;

        LoggerService.logInfo('Action - getAllInvoices - End - Success');

        return ResultModel.newSuccessResultTyped<GetAllInvoicesSchemaType['results']>(data, metadata);
    }
    catch (error) {
        LoggerService.logInfo('Action - getAllInvoices - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récuperation de la liste des factures.',
            error: error
        });

        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
